import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Bank, BusinessField } from '../models';
import { map } from 'rxjs/operators';

@Injectable()
export class DictionariesService {
  constructor(private readonly http: HttpClient) {}

  getBanks() {
    const url = '/api/payment-contracts/client/banks/il';
    return this.http.get<{ items: any[] }>(url).pipe(
      map((res) =>
        res.items.map(
          (i) =>
            ({
              code: i.code,
              localName: i.local_name,
              internationalName: i.international_name,
            }) as Bank,
        ),
      ),
    );
  }

  getBusinessFields() {
    const url = '/api/payment-contracts/client/business-fields';
    return this.http.get<{ items: any[] }>(url).pipe(
      map((res) =>
        res.items.map(
          (i) =>
            ({
              code: i.code,
              localName: i.name_local,
              internationalName: i.name_intl,
            }) as BusinessField,
        ),
      ),
    );
  }
}
